import generateCalendar from "antd/es/calendar/generateCalendar";
import dayjs from "dayjs";
// eslint-disable-next-line import/no-extraneous-dependencies
import dayJsConfig from "rc-picker/es/generate/dayjs";

const Calendar = generateCalendar<Date>({
  getWeekDay: (value: Date): number => dayJsConfig.getWeekDay(dayjs(value)),
  getSecond: (value: Date): number => dayJsConfig.getSecond(dayjs(value)),
  getMinute: (value: Date): number => dayJsConfig.getMinute(dayjs(value)),
  getHour: (value: Date): number => dayJsConfig.getHour(dayjs(value)),
  getDate: (value: Date): number => dayJsConfig.getDate(dayjs(value)),
  getMonth: (value: Date): number => dayJsConfig.getMonth(dayjs(value)),
  getYear: (value: Date): number => dayJsConfig.getYear(dayjs(value)),
  getNow: (): Date => new Date(),
  getFixedDate: (fixed: string): Date =>
    dayJsConfig.getFixedDate(fixed).toDate(),
  getEndDate: (value: Date): Date =>
    dayJsConfig.getEndDate(dayjs(value)).toDate(),
  addYear: (value: Date, diff: number): Date =>
    dayJsConfig.addYear(dayjs(value), diff).toDate(),
  addMonth: (value: Date, diff: number): Date =>
    dayJsConfig.addMonth(dayjs(value), diff).toDate(),
  addDate: (value: Date, diff: number): Date =>
    dayJsConfig.addDate(dayjs(value), diff).toDate(),
  setYear: (value: Date, year: number): Date =>
    dayJsConfig.setYear(dayjs(value), year).toDate(),
  setMonth: (value: Date, month: number): Date =>
    dayJsConfig.setMonth(dayjs(value), month).toDate(),
  setDate: (value: Date, date: number): Date =>
    dayJsConfig.setDate(dayjs(value), date).toDate(),
  setHour: (value: Date, hour: number): Date =>
    dayJsConfig.setHour(dayjs(value), hour).toDate(),
  setMinute: (value: Date, minute: number): Date =>
    dayJsConfig.setMinute(dayjs(value), minute).toDate(),
  setSecond: (value: Date, second: number): Date =>
    dayJsConfig.setSecond(dayjs(value), second).toDate(),
  isAfter: (date1: Date, date2: Date): boolean =>
    dayJsConfig.isAfter(dayjs(date1), dayjs(date2)),
  isValidate: (date: Date): boolean => dayjs(date).isValid(),
  locale: {
    getWeekFirstDay: (locale: string): number =>
      dayJsConfig.locale.getWeekFirstDay(locale) + 1,
    getWeekFirstDate: (locale: string, value: Date): Date =>
      dayJsConfig.locale.getWeekFirstDate(locale, dayjs(value)).toDate(),
    getWeek: (locale: string, value: Date): number =>
      dayJsConfig.locale.getWeek(locale, dayjs(value)),
    format: (locale: string, date: Date, dateFormat: string): string =>
      dayJsConfig.locale.format(locale, dayjs(date), dateFormat),
    /** Should only return validate date instance */
    parse: (locale: string, text: string, formats: string[]): Date | null => {
      const result = dayJsConfig.locale.parse(locale, text, formats);

      return result ? result.toDate() : null;
    },
    /** A proxy for getting locale with moment or other locale library */
    getShortWeekDays: (locale: string): string[] =>
      dayJsConfig.locale.getShortWeekDays?.(locale) || [],
    /** A proxy for getting locale with moment or other locale library */
    getShortMonths: (locale: string): string[] =>
      dayJsConfig.locale.getShortMonths?.(locale) || [],
  },
});

export default Calendar;
